/*eslint-disable*/ export const messages = JSON.parse("{\"radio-group.validation.required\":[\"Please select an option.\"],\"radio-group.label.optional\":[\"Optional\"]}");
//# sourceMappingURL=messages.mjs.map